import { readonly, ref } from 'vue';
import { PrinterModel, STOREClientService } from '@/storecontext/shared/api/server-apis';
import utilitiesService from '@/shared/utilities.service';

const printers = ref<PrinterModel[]>([]);
const defaultPrinter = ref<string | number>();

export function usePrinters(usePrinterName: boolean) {
    const fetchAndSetPrinters = async() => {
        const response = await STOREClientService.getPrintersByStore().then(utilitiesService.unwrapModel);
        printers.value = response as PrinterModel[];
        defaultPrinter.value = usePrinterName ? printers.value[0].name : printers.value[0].id;
    };

    fetchAndSetPrinters();

    return {
        defaultPrinter,
        printers: readonly(printers),
    };
}
